(function () {
function $d4be13ec4caa7783$export$2e2bcd8739ae039() {
    const accordionsCooontainer = document.querySelectorAll("[js-accordion-container]");
    if (!accordionsCooontainer) return;
    accordionsCooontainer.forEach((container)=>{
        container.addEventListener("click", handleClick);
        function handleClick(e) {
            const target = e.target;
            const title = target.classList.contains(".accordion-title") || target.closest(".accordion-title");
            if (title) {
                const attrParent = title.getAttribute(`js-comentario-parent`);
                if (attrParent) //parent accordion
                document.querySelectorAll(`.accordion-title[js-comentario-parent="${attrParent}"]`).forEach((i)=>{
                    if (i !== title) {
                        if (i.closest(".accordion-item").classList.contains("active")) i.click();
                    }
                });
                const idAccordion = title.getAttribute("data-accordion");
                const content = container.querySelector(`.accordion-content[data-accordion="${idAccordion}"]`);
                const height = content.scrollHeight;
                title.closest(".accordion-item").classList.toggle("active");
                content.classList.toggle("active");
                if (content.classList.contains("active")) gsap.fromTo(content, {
                    height: 0
                }, {
                    height: height,
                    duration: 0.3
                });
                else gsap.fromTo(content, {
                    height: height
                }, {
                    height: 0,
                    duration: 0.3
                });
            }
        }
    });
}


function $b817774f4e121b87$export$2e2bcd8739ae039() {
    const attr = "[js-breadcrumb]";
    const breadcrumb = document.querySelector(`.breadcrumb${attr}`);
    const objStr = breadcrumb?.dataset.obj;
    if (!breadcrumb || !objStr) return;
    const obj = JSON.parse(objStr.replaceAll(`'`, `"`));
    const aLength = obj.length - 1;
    const items = obj.map(({ name: name, slug: slug, link: link }, index)=>`
		<li class="${index === aLength ? "active" : ""}">
			<a ${link ? `href="${link}"` : ""} data-slug="${slug}">${name}</a>
		</li>
		`);
    const template = ()=>{
        return `
			<ul class="flex flex-wrap breadcrumb-wrapper">
				
				${items.join("")}
			</ul>
		`;
    };
    breadcrumb.innerHTML = template();
    if (GLOBAL.isTablet) {
        const breadMobile = document.querySelector(".breadcrumb-mobile");
        breadMobile.appendChild(breadcrumb);
    }
}


function $62aa7eab14c9b56b$export$2e2bcd8739ae039(element, events, callback) {
    const outside = "data-outside";
    const html = document.documentElement;
    if (!element.hasAttribute(outside)) {
        events.forEach((userEvent)=>{
            html.addEventListener(userEvent, handleOutsideClick) //adiciona evento de click que vai aproveitar do bubble
            ;
        });
        element.setAttribute(outside, "") //coloca atributo para nao adicionar o evento mais de uma vez
        ;
    }
    function handleOutsideClick(event) {
        if (!element.contains(event.target)) {
            element.removeAttribute(outside, "");
            events.forEach((userEvent)=>{
                html.removeEventListener(userEvent, handleOutsideClick) //adiciona evento de click que vai aproveitar do bubble
                ;
            });
            callback();
        }
    }
}


function $a33731548c30a3e0$export$2e2bcd8739ae039() {
    const dropdownMenus = document.querySelectorAll('[js-dropdown]');
    dropdownMenus.forEach((menu)=>{
        [
            'touchstart',
            'click'
        ].forEach((userEvent)=>{
            menu.addEventListener(userEvent, handleClick);
        });
    });
    function handleClick(event) {
        // event.preventDefault(); //retirar se tiver click no item
        dropdownMenus.forEach((i)=>i.classList.remove("active"));
        this.classList.add('active');
        // outside click pode ser reaproveitado para outros eventos de bubble
        (0, $62aa7eab14c9b56b$export$2e2bcd8739ae039)(this, [
            'touchstart',
            'click',
            "mouseleave"
        ], ()=>{
            this.classList.remove("active");
        });
    }
}


function $c181609a2822c4d3$export$2e2bcd8739ae039() {
    const hasInlines = document.querySelector("[data-js-inline]");
    if (!hasInlines) return;
    function addRemoveEventInExistingInlines() {
        const btnsRemoveInline = document.querySelectorAll("[class*='remove_inline']");
        btnsRemoveInline.forEach((btn)=>{
            const inline = btn.closest('.inline-item');
            btn.addEventListener('click', ()=>removeInline(inline));
        });
    }
    function checkMaxNumAllForms() {
        const maxNumbersElements = document.querySelectorAll("[id$='-MAX_NUM_FORMS']");
        // console.log(maxNumbersElements)
        maxNumbersElements.forEach((numberElement)=>{
            const wrapperInline = numberElement.closest('.wrapper-inline');
            console.log(numberElement.value, numberElement);
            checkMaxNumForm(numberElement.value, wrapperInline);
        });
    }
    function checkMaxNumForm(totalForms, wrapperInline) {
        // console.log(wrapperInline)
        const inlineItens = wrapperInline.querySelectorAll('.inline-item');
        if (inlineItens.length === Number(totalForms)) {
            const dataJsInline = wrapperInline.dataset.jsInline;
            const btnAddInline = document.querySelector(`.add_inline[data-js-inline='${dataJsInline}']`);
            btnAddInline.classList.add('hidden');
        }
    }
    function addAddEventInExistingInlines() {
        const btnsAddInline = document.querySelectorAll('.add_inline');
        btnsAddInline && btnsAddInline.forEach((btnAddInline)=>{
            btnAddInline.addEventListener('click', ()=>addInline(btnAddInline.dataset.jsInline));
        });
    }
    function addInline(dataJsInline) {
        const wrapperInline = document.querySelector(`.wrapper-inline[data-js-inline='${dataJsInline}']`);
        const inputMaxForms = wrapperInline.querySelector("[id$='-MAX_NUM_FORMS']");
        const inputFormIndex = wrapperInline.querySelector("[id$='-TOTAL_FORMS']");
        const intFormIndex = parseInt(inputFormIndex.value);
        const emptyForm = $(`.empty_inline_form[data-js-inline='${dataJsInline}']`);
        $(wrapperInline).append(emptyForm.html().replace(/__prefix__/g, intFormIndex));
        const removeBtn = wrapperInline.querySelector(`.remove_inline-${intFormIndex}`);
        const inline = document.querySelector(`.inline-${intFormIndex}[data-js-inline=${dataJsInline}]`);
        removeBtn.addEventListener('click', ()=>removeInline(inline));
        inputFormIndex.value = intFormIndex + 1;
        if (wrapperInline.children) [
            ...wrapperInline.children
        ].forEach((child)=>{
            child.setAttribute("new-inline", false);
        });
        extraConfigs(inline);
        checkMaxNumForm(inputMaxForms.value, wrapperInline);
    }
    function removeInline(inline) {
        const wrapperInline = inline.closest(".wrapper-inline");
        const inputMaxForms = wrapperInline.querySelector("[id$='-MAX_NUM_FORMS']");
        const deleteBtn = inline.querySelector(`[id$='-DELETE'`);
        deleteBtn.setAttribute('checked', true);
        inline.classList.add('hidden');
        checkMaxNumForm(inputMaxForms.value, wrapperInline);
    }
    function extraConfigs(inline) {
        inline.setAttribute("new-inline", true);
        const selects = inline.querySelectorAll('select');
        const props = {
            searchEnabled: true,
            searchChoices: true
        };
        selects.forEach((select)=>GLOBAL.initChoices(select, props));
    }
    (function init() {
        addAddEventInExistingInlines();
        addRemoveEventInExistingInlines();
        checkMaxNumAllForms();
    })();
}


function $3d674e921bc9a223$export$2e2bcd8739ae039() {
//seta em todos esses tipos de input a classe active
// se tiver length
// const attr = "[js-ativo]"
// const type = `
// input[type='text']${attr}, 
// input[type='number']${attr}, 
// input[type='email']${attr},
// textarea${attr}
// `
// const inputs = document.querySelectorAll(type)
// // console.log('inputs', inputs)
// inputs?.forEach(input => handleClass(false)(input))
// inputs?.forEach(input => input.addEventListener('change', handleClass(true)))
// function handleClass(isEvent) {
// 	return (event) => {
// 		const input = isEvent ? event.currentTarget : event
// 		input.value.length !== 0
// 			? input.classList.add('active')
// 			: input.classList.remove('active')
// 	}
// }
}


const { isTablet: $26cf995f5276a8f6$var$isTablet, debounceFunction: $26cf995f5276a8f6$var$debounceFunction } = GLOBAL;
function $26cf995f5276a8f6$export$2e2bcd8739ae039(obj) {
    let state = {
        open: false,
        delay: 150
    };
    const sidebar = document.querySelector('.sidebar');
    if (!sidebar) return;
    if (!obj) return;
    const body = document.body;
    const svgAdicionar = `<svg><use xlink:href="#icon_add"></use></svg>`;
    const svgList = `<svg><use xlink:href="#icon_list"></use></svg>`;
    const svgArrow = `<svg class="icon group-hover:opacity-100 icon-arrow"><use xlink:href="#icon_arrow_left"></use></svg>`;
    const iconBack = `<svg class="icon-back group-hover:opacity-100 icon-arrow h-32 w-32"><use xlink:href="#icon_back_arrow"></use></svg>`;
    const tipyAdicionar = 'data-tippy-content="Adicionar"';
    const tipyList = 'data-tippy-content="Lista"';
    const fundo = document.querySelector('.nav-fundo ');
    const itensLV0 = sidebar.querySelectorAll('[js-menu-lista]  > li[js-lista-name] ');
    const toogle = document.querySelector('[js-menu-toggle]');
    // Titulo
    const templateModuleName = (name, icon)=>`<li class='module-name'>${icon && !$26cf995f5276a8f6$var$isTablet ? icon.outerHTML : ''} ${$26cf995f5276a8f6$var$isTablet ? iconBack : ''}  ${name}<li>`;
    // Me de o menu pertencente
    const getStaticMenu = (slug)=>document.querySelector(`[js-menu-lista] [js-lista-name='${slug}']`);
    // Popula os leveis do menu
    const populateMenuLevel = (itemMenu, submenu, name, svg)=>{
        const templateSubMenu = templateLevelMenu(submenu);
        const templateItems = submenu.items.map(templateItensSubmenu);
        templateSubMenu.innerHTML = templateItems.join('');
        templateSubMenu.insertAdjacentHTML('afterbegin', templateModuleName(name, svg));
        itemMenu.appendChild(templateSubMenu);
        itemMenu.classList.add('have-submenu');
    };
    // Template das liZ
    const templateItensSubmenu = (item)=>{
        const { name: name, link: link, list: list, adicionar: adicionar, slug: slug, submenu: submenu } = item;
        // console.log(item)
        return `
				<li class="group" js-lista-name='${slug}' ${submenu ? `data-submenu` : ''}>
					<div class="item-wrapper">
						<a ${link ? `href="${link}"` : ''} class='item'> ${name}	</a>
						${adicionar ? `<a ${tipyAdicionar} class='adicionar' href="${adicionar}">${svgAdicionar}</a>` : ''}
						${list ? `<a ${tipyList} class='lista' href="${list}">${svgList}</a>` : ''}
						${submenu ? svgArrow : ''}
					</div>
				</li>`;
    };
    // Template dos sublevel
    const templateLevelMenu = (submenu)=>{
        const div = document.createElement('ul');
        div.setAttribute('data-level', submenu.level);
        div.classList.add('submenu');
        return div;
    };
    //Cria subMenus
    const createSubMenus = ({ slug: slug, submenu: submenu, name: name })=>{
        const itemMenu1 = getStaticMenu(slug);
        const svg = itemMenu1.querySelector('svg').cloneNode(true);
        svg.style.setProperty('--cor-1', 'white');
        if (!submenu) return;
        populateMenuLevel(itemMenu1, submenu, name, svg);
        submenu.items.forEach(({ slug: slug, submenu: submenu, name: name })=>{
            const itemMenu2 = getStaticMenu(slug);
            if (!submenu) return;
            populateMenuLevel(itemMenu2, submenu, name);
            submenu.items.forEach(({ slug: slug, submenu: submenu, name: name })=>{
                const itemMenu3 = getStaticMenu(slug);
                if (!submenu) return;
                populateMenuLevel(itemMenu3, submenu, name);
            });
        });
    };
    const handleClickFundo = ()=>{
        itensLV0.forEach((i)=>i.classList.remove('active'));
        body.classList.remove('menu-ativo');
        toogleMenu();
    };
    const handleClickItem = (i)=>(e)=>{
            if (e.isTrusted && (e.target.tagName == 'A' || e.target.closest('a'))) return;
            setTimeout(()=>sidebar.classList.add('animou'), 200) //add classe para animar apenas uma vez
            ;
            body.classList.add('menu-ativo') //add classe para mostrar o fundo do menu
            ;
            itensLV0.forEach((i)=>i.classList.remove('active')) //remove ativo tds outros
            ;
            body.classList.remove('dont-open-submenu') // remove a classe que impede que o submenu seja aberto
            ;
            i.classList.toggle('active');
        };
    const toogleMenu = (e)=>{
        //calback hover menu
        //funcao do jquery que me da mais certeza c o menu esta aberto ou n
        if (!$26cf995f5276a8f6$var$isTablet) {
            if (body.classList.contains('menu-ativo')) return;
            state.open = !$(sidebar).is(':hover');
        }
        // console.log(state.open);
        if (state.open) {
            // if(e)
            body.classList.add('menu-closed');
            body.classList.add('dont-open-submenu');
            sidebar.classList.remove('animou');
            if ($26cf995f5276a8f6$var$isTablet) {
                state.open = false;
                body.classList.remove('menu-ativo');
            }
        } else {
            body.classList.remove('menu-closed');
            body.classList.remove('menu-ativo');
            if ($26cf995f5276a8f6$var$isTablet) state.open = true;
        }
    };
    // const showLevelActive = (e) => {
    // 	const level = Number(e.target.closest(".have-submenu")?.querySelector(".submenu").dataset.level) + 1
    // 	console.log(level);
    // 	if (level === 3) sidebar.setAttribute("data-radius", "3")
    // 	if (level === 2) sidebar.setAttribute("data-radius", "2")
    // 	if (level === 1) sidebar.setAttribute("data-radius", "1")
    // }
    const backLevel = (e)=>{
        setTimeout(()=>itensLV0.forEach((i)=>i.classList.remove('active')), 100);
    };
    const events = ()=>{
        itensLV0.forEach((i)=>i.addEventListener('click', handleClickItem(i)));
        if ($26cf995f5276a8f6$var$isTablet) {
            toogle?.addEventListener('click', toogleMenu);
            document.querySelectorAll('.icon-back').forEach((i)=>i.addEventListener('click', backLevel));
        } else {
            sidebar.addEventListener('mouseenter', $26cf995f5276a8f6$var$debounceFunction(toogleMenu, state.delay));
            sidebar.addEventListener('mouseout', toogleMenu);
            fundo.addEventListener('click', handleClickFundo);
        }
    // sidebar.addEventListener("mousemove", showLevelActive)
    };
    function agruparDropdownsPorGrupo() {
        const menu = document.querySelector('[js-menu-lista]');
        if (!menu) return;
        // Busca todos os li com data-menu-group
        const itens = Array.from(menu.querySelectorAll('li[data-menu-group]'));
        // Agrupa por valor do atributo
        const grupos = {};
        itens.forEach((li)=>{
            const grupo = li.getAttribute('data-menu-group');
            if (!grupos[grupo]) grupos[grupo] = [];
            grupos[grupo].push(li);
        });
        // Remove os itens do menu principal
        itens.forEach((li)=>menu.removeChild(li));
        // Cria os dropdowns e insere no início do menu
        const dropdowns = [];
        Object.entries(grupos).forEach(([grupo, itensGrupo])=>{
            const { liDropdown: liDropdown, ulDropdown: ulDropdown } = criarEstruturaDropdown(grupo);
            itensGrupo.forEach((item)=>ulDropdown.appendChild(item));
            dropdowns.push(liDropdown);
        });
        // Insere todos os dropdowns no início do menu
        dropdowns.reverse().forEach((dropdown)=>{
            menu.insertBefore(dropdown, menu.firstChild);
        });
    }
    function criarEstruturaDropdown(grupo) {
        const liDropdown = document.createElement('li');
        liDropdown.className = 'sidebar-group-dropdown';
        const titulo = document.createElement('a');
        titulo.href = '#';
        titulo.className = 'sidebar-nav-button';
        titulo.dataset.fullname = grupo;
        const lastWord = grupo.trim().split(' ').pop();
        titulo.dataset.shortname = lastWord;
        titulo.textContent = grupo;
        const svgSeta = document.createElement('span');
        svgSeta.className = 'sidebar-dropdown-arrow';
        svgSeta.innerHTML = `<svg class="w-16 h-16"><use xlink:href="#icon_arrow_up"></use></svg>`;
        titulo.appendChild(svgSeta);
        const ulDropdown = document.createElement('ul');
        ulDropdown.className = 'sidebar-drop-down closed';
        titulo.addEventListener('click', function(e) {
            e.preventDefault();
            ulDropdown.classList.toggle('closed');
            svgSeta.classList.toggle('open', !ulDropdown.classList.contains('closed'));
        });
        liDropdown.appendChild(titulo);
        liDropdown.appendChild(ulDropdown);
        // Troca nome quando sidebar está minimizado
        function updateDropdownName() {
            // Atualiza só o texto, mantendo o SVG
            const texto = document.body.classList.contains('menu-closed') ? titulo.dataset.shortname : titulo.dataset.fullname;
            // Se já existe um nó de texto, atualiza; senão, cria
            if (titulo.childNodes.length > 0 && titulo.childNodes[0].nodeType === Node.TEXT_NODE) titulo.childNodes[0].textContent = texto;
            else titulo.insertBefore(document.createTextNode(texto), titulo.firstChild);
        }
        updateDropdownName();
        document.body.addEventListener('classChange', updateDropdownName);
        // fallback para mudanças via JS
        const observer = new MutationObserver(updateDropdownName);
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
        return {
            liDropdown: liDropdown,
            ulDropdown: ulDropdown
        };
    }
    function abrirGrupoMenuPorAbaAtiva() {
        const menu = document.querySelector('[js-menu-lista]');
        if (!menu) return;
        const SAP_GROUP = "Gest\xe3o SAP";
        const pathnameStart = window.location.pathname;
        const isRoot = pathnameStart === '/' || pathnameStart === '';
        if (isRoot) {
            const dropdown = Array.from(menu.querySelectorAll('.sidebar-group-dropdown')).find((li)=>li.querySelector('.sidebar-nav-button')?.dataset.fullname === SAP_GROUP);
            if (dropdown) {
                const ulDropdown = dropdown.querySelector('.sidebar-drop-down');
                const svgSeta = dropdown.querySelector('.sidebar-dropdown-arrow');
                ulDropdown.classList.remove('closed');
                svgSeta.classList.add('open');
            }
            return; // Não executa o restante da lógica na primeira visita
        }
        // Encontra o item ativo (pode ser por URL ou classe, ajuste conforme seu HTML)
        const pathname = window.location.pathname;
        const liAtivo = Array.from(menu.querySelectorAll('li[js-lista-name]')).find((li)=>{
            const link = li.querySelector('a.menu-item');
            return link && link.href && link.href.includes(pathname);
        });
        if (liAtivo) {
            const grupo = liAtivo.getAttribute('data-menu-group');
            if (grupo) {
                // Procura o dropdown do grupo e abre
                const dropdown = Array.from(menu.querySelectorAll('.sidebar-group-dropdown')).find((li)=>li.querySelector('.sidebar-nav-button')?.dataset.fullname === grupo);
                if (dropdown) {
                    const ulDropdown = dropdown.querySelector('.sidebar-drop-down');
                    const svgSeta = dropdown.querySelector('.sidebar-dropdown-arrow');
                    ulDropdown.classList.remove('closed');
                    svgSeta.classList.add('open');
                }
            }
        }
    }
    function init() {
        agruparDropdownsPorGrupo();
        obj.forEach(createSubMenus);
        events();
        abrirGrupoMenuPorAbaAtiva();
        return this;
    }
    return {
        init: init,
        toogleMenu: toogleMenu
    };
}


function $35e50930b820f781$export$2e2bcd8739ae039() {
    const attr = document.querySelector("[data-secao]");
    if (!attr) return;
    const secao = GLOBAL.url.searchParams.get('secao');
    const wrapperSecao = document.querySelector(`[data-secao='${secao}']`);
    wrapperSecao && wrapperSecao.classList.remove('hidden');
}


function $0766db45a0d564be$export$2e2bcd8739ae039() {
    const { url: url } = GLOBAL;
    if (url.searchParams.has('mensagem_toastify')) {
        const mensagemToastify = url.searchParams.get('mensagem_toastify');
        Toastify({
            text: mensagemToastify,
            duration: 3000,
            position: 'center'
        }).showToast();
        url.searchParams.set('mensagem_toastify', '');
        url.search = "";
        window.history.pushState({}, '', url);
    }
}


function $7d6c7a0efe32d209$export$2e2bcd8739ae039() {
    const allSelects = [
        ...document.querySelectorAll('select[js-choices]')
    ]?.filter((select)=>!select.hasAttribute('js-no-choices'));
    if (!allSelects) return;
    const listOfChoices = [
        ...allSelects
    ].map((i)=>{
        const hasAttr = i.getAttribute('js-choices-props');
        const props = hasAttr ? JSON.parse(hasAttr) : {};
        return GLOBAL.initChoices(i, {
            searchEnabled: false,
            searchChoices: false,
            itemSelectText: 'Selecionar',
            noResultsText: 'Nada Encontrado...',
            noResultsText: '...',
            noChoicesText: '...',
            ...props
        });
    });
    window.listOfChoices = listOfChoices;
}


function $0e9464acf29c4d03$export$2e2bcd8739ae039() {
    const attr = "[js-tab]";
    const tabs = document.querySelectorAll(`.tabs${attr}`);
    if (!tabs.length) return;
    tabs.forEach((t)=>initTab(t));
    function initTab(tab) {
        const collapses = tab.querySelectorAll(".tab-collapse");
        const tabItens = tab.querySelectorAll(".tabs-wrapper .tab-item");
        tabItens.forEach((t)=>{
            t.addEventListener("click", (e)=>{
                collapses.forEach((c)=>c.classList.remove("active"));
                tabItens.forEach((c)=>c.classList.remove("active"));
                t.classList.add("active");
                const att = e.currentTarget.dataset.tab;
                collapses.forEach((c)=>{
                    const attCollapse = c.getAttribute("data-tab");
                    if (attCollapse == att) c.classList.add("active");
                });
            });
        });
    }
}


function $c57268cbdda7e760$export$2e2bcd8739ae039() {
    const attr = "[js-password]";
    const divs = document.querySelectorAll(`.show-password${attr}`);
    if (!divs.length) return;
    function handleEvent(div) {
        return function(event) {
            let input = div.querySelector("[js-input-password]");
            let item = event.currentTarget;
            input.type = input.type == 'text' ? 'password' : 'text';
            if (input.type == 'text') item.classList.add("mostra");
            else item.classList.remove("mostra");
        };
    }
    divs.forEach((div)=>{
        const buttonPass = div.querySelector('.password');
        buttonPass.addEventListener('click', handleEvent(div));
    });
}


function $952685f69e534542$export$2e2bcd8739ae039() {
    const attr = "js-add-filter";
    const els = document.querySelectorAll(`[${attr}]`);
    if (!els.length) return;
    els.forEach((i)=>i.addEventListener("click", handleCallback));
    function handleCallback(e) {
        e.preventDefault();
        const target = e.currentTarget;
        const filtro = target.getAttribute("js-add-filter")?.split(",");
        const [param, value] = filtro;
        const valueClean = value?.trim();
        const url = new URL(window.location);
        let filtersOBJ = GLOBAL.splitFilters(url.search);
        console.log('aqqq', filtersOBJ);
        // const haveSameFilter = filtersOBJ ? filtersOBJ[param] : false
        if (filtersOBJ) {
            if (param === "order" && filtersOBJ.order?.replace("-", "") === valueClean) {
                if (target.classList.contains("up")) filtersOBJ[param] = `-${valueClean}`;
                else filtersOBJ[param] = valueClean;
            } else filtersOBJ[param] = valueClean;
        } else {
            filtersOBJ = {};
            filtersOBJ[param] = value;
        }
        const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
        window.location.href = `${url.origin}${url.pathname}${newFilters}`;
    }
}


function $0460917e066ef034$export$2e2bcd8739ae039() {
    const attr = "[js-badge]";
    const badges = document.querySelectorAll(`.badge${attr}`);
    if (!badges.length) return;
    badges.forEach((badge)=>{
        const color = getComputedStyle(badge).getPropertyValue("--color");
        if (!color) return;
        badge.style.color = color;
        badge.style.background = GLOBAL.addAlpha(color, 0.1);
    });
}


function $b9e705216f990553$export$2e2bcd8739ae039(wrapperBadge, wrapperFields) {
    const attr = document.querySelector("[js-modal-filtrar]");
    if (!attr) return;
    const token = 'csrfmiddlewaretoken';
    const ativos = "<p class='text-sm font-semibold text-neutral-80'>Filtros Ativos</p>";
    const btnLimpar = document.querySelector('[js-limpar-filtro]');
    const geraBadge = (item)=>`<div class="badge">${item}</div>`;
    function filtrosAtivos(wrapper) {
        const url = new URL(window.location);
        // const urlSearchParams = new URLSearchParams(url);
        // const params = Object.fromEntries(urlSearchParams.entries());
        // const array = Object.entries(params);	
        // console.log(params)
        let filtersOBJ = GLOBAL.splitFilters(url.search);
        console.log(url.search);
        console.log('obj', filtersOBJ);
        if (!filtersOBJ) return;
        btnLimpar?.classList.remove("hidden");
        const filterArray = Object.entries(filtersOBJ);
        const template = filterArray.filter(([key, value])=>value && key != token).map(([key, value])=>geraBadge(key.replaceAll('_', ' ')));
        template.unshift(ativos);
        wrapper.innerHTML = template.join("");
        setValueOnFields(wrapper, filtersOBJ);
    }
    function setValueOnFields(wrapper, obj) {
        const objArr = Object.entries(obj);
        objArr.forEach(([key, value])=>{
            const field = wrapperFields.querySelector(`[name="${key}"]`);
            if (!field) return;
            const type = field.tagName;
            if (type === "SELECT") {
                const select = GLOBAL.getChoicesActive(field.id, listOfChoices);
                select.setChoiceByValue(value);
            }
            if (type === "INPUT") // const str = "ç_--áäàãa@! teste}{\ ";
            field.value = decodeURIComponent(value.replaceAll(/\+/g, ' '));
        });
    }
    function limparFiltros() {
        const url = new URL(window.location);
        console.log(url.pathname);
        window.location.href = `${url.origin}${url.pathname}`;
    }
    function init() {
        document.addEventListener("DOMContentLoaded", ()=>filtrosAtivos(wrapperBadge));
        btnLimpar.addEventListener("click", limparFiltros);
    }
    return {
        init: init
    };
}


function $3e074429cadb145d$export$2e2bcd8739ae039() {
    document.querySelectorAll("table[js-dataTables]")?.forEach((t)=>{
        const props = t.dataset.props || {};
        const classe = t.dataset.classe || "no class";
        const Dtable = $(t).DataTable({
            language: {
                show: "Visualizar",
                lengthMenu: "Mostrar _MENU_ linhas por p\xe1gina",
                zeroRecords: "Nada encontrado",
                info: "Exibindo p\xe1gina _PAGE_ de _PAGES_",
                infoEmpty: "Nada encontrado",
                infoFiltered: "(filtrado de _MAX_ no total)",
                search: "Pesquisar",
                paginate: {
                    previous: "Anterior",
                    next: "Pr\xf3xima"
                }
            },
            searching: false,
            autoWidth: true,
            ordering: true,
            order: [
                [
                    0,
                    "desc"
                ]
            ],
            select: {
                items: "cell"
            },
            responsive: true,
            paginate: false,
            search: false,
            info: false,
            ...props
        });
        GLOBAL.wrap_single(t, "div", [
            "table-container",
            ...classe.split(" ")
        ]);
    });
}


function $7ea5127b6ed5228b$export$2e2bcd8739ae039() {
    const attr = "js-table-search";
    const els = document.querySelectorAll(`[${attr}]`);
    const url = new URL(window.location);
    let filtersOBJ = GLOBAL.splitFilters(url.search);
    if (!els.length) return;
    els.forEach((i)=>{
        const wrapper = i.closest(".input-container");
        const btn = wrapper.querySelector("button");
        btn.addEventListener("click", search(i));
        i.addEventListener("keyup", (e)=>{
            if (e.keyCode == 13) search(i)(e);
        });
    });
    function search(input) {
        return (e)=>{
            const target = e.currentTarget;
            if (filtersOBJ) filtersOBJ["filter"] = input.value;
            else {
                filtersOBJ = {};
                filtersOBJ["filter"] = input.value;
            }
            const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = `${url.origin}${url.pathname}${newFilters}`;
        };
    }
}


function $2c624524ddc404f0$export$2e2bcd8739ae039() {
    const attr = "js-table-qnt";
    const els = document.querySelectorAll(`[${attr}]`);
    const url = new URL(window.location);
    let filtersOBJ = GLOBAL.splitFilters(url.search);
    if (!els.length) return;
    els.forEach((i)=>{
        i.addEventListener("change", search(i));
        if (!filtersOBJ) return;
        if (filtersOBJ["paginate_by"]) {
            const select = GLOBAL.getChoicesActive(i.id, listOfChoices);
            select.setChoiceByValue(filtersOBJ["paginate_by"]);
        }
    });
    function search(input) {
        return (e)=>{
            const target = e.currentTarget;
            const url = new URL(window.location);
            let filtersOBJ = GLOBAL.splitFilters(url.search);
            if (filtersOBJ) filtersOBJ["paginate_by"] = target.value;
            else {
                filtersOBJ = {};
                filtersOBJ["paginate_by"] = target.value;
            }
            const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = `${url.origin}${url.pathname}${newFilters}`;
        };
    }
}


function $e9b61f650e542eed$export$2e2bcd8739ae039() {
    const attr = "js-table-recentes";
    const els = document.querySelectorAll(`[${attr}]`);
    const url = new URL(window.location);
    let filtersOBJ = GLOBAL.splitFilters(url.search);
    if (!els.length) return;
    els.forEach((i)=>{
        i.addEventListener("change", search(i));
        if (!filtersOBJ) return;
        if (filtersOBJ["order"]) {
            const select = GLOBAL.getChoicesActive(i.id, listOfChoices);
            select.setChoiceByValue(filtersOBJ["order"]);
        }
    });
    function search(input) {
        return (e)=>{
            const url = new URL(window.location);
            let filtersOBJ = GLOBAL.splitFilters(url.search);
            const target = e.currentTarget;
            if (filtersOBJ) filtersOBJ["order"] = target.value;
            else {
                filtersOBJ = {};
                filtersOBJ["order"] = target.value;
            }
            const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = `${url.origin}${url.pathname}${newFilters}`;
        };
    }
}


function $712fc3ffc02f9551$export$2e2bcd8739ae039() {
    const attr = "js-table-ordenation";
    const els = document.querySelectorAll(`table[${attr}]`);
    if (!els.length) return;
    const url = GLOBAL.url;
    const filtersOBJ = GLOBAL.splitFilters(url.search);
    const order = filtersOBJ?.order;
    if (!order) return;
    const upOrDown = order?.includes("-") ? "down" : "up";
    console.log("FILTROS ATIVOS", filtersOBJ);
    els.forEach((table)=>{
        console.log(order);
        const th = table.querySelector(`thead [data-reference='${order.replace("-", "")}']`);
        console.log("th", th);
        th?.classList.add(upOrDown);
    });
}


function $fb55be7f197d78d8$export$2e2bcd8739ae039() {
    const radios = document.querySelectorAll('.radio-style');
    // console.log(radios, 'radios')
    function geraTemplateRadioLabel(div, labelAntiga) {
        return `<label class="check-label">${div.innerHTML} <span class="radio-circle">
					<i class="radio-circle-inner"></i>
			</span>${labelAntiga}</label>`;
    }
    function itemLista(radio) {
        const label = radio.querySelector('label');
        const input = label.querySelector('input');
        input.classList.add('sr-only');
        const div = document.createElement('div');
        div.append(input);
        radio.innerHTML = geraTemplateRadioLabel(div, label.innerText);
    }
    radios.forEach((radio)=>{
        itemLista(radio);
    });
}


function $afec8e251cea5e73$export$2e2bcd8739ae039(loader) {
    const textDefault = [
        "Processando as informa\xe7\xf5es",
        'Mais um pouco...',
        "Quase l\xe1..."
    ];
    const loaderEL = document.querySelector('.loader--container') || loader;
    const pEl = loaderEL.querySelector('p');
    let interval;
    /**
	 * @param {array} opcional | recebe um array de objetos para ser mostrado
	 */ function show(options) {
        loaderEL.dataset.active = 'true';
        let atual = 0;
        const obj = {
            textos: textDefault,
            time: 8000,
            ...options
        };
        $(pEl).text(obj.textos[atual]);
        interval = setInterval(function() {
            $(pEl).fadeOut(function() {
                if (atual > obj.textos.length) atual = 0;
                $(pEl).text(obj.textos[atual]).fadeIn();
                atual = atual + 1;
            });
        }, obj.time);
        return this;
    }
    function hide() {
        loaderEL.dataset.active = 'false';
        clearInterval(interval);
        pEl.innerText = '';
        return this;
    }
    return {
        show: show,
        hide: hide
    };
}


// dataTablesInit()
(0, $7d6c7a0efe32d209$export$2e2bcd8739ae039)() //inicia bibiloteca Choices.js
;
(0, $d4be13ec4caa7783$export$2e2bcd8739ae039)();
(0, $b817774f4e121b87$export$2e2bcd8739ae039)();
(0, $a33731548c30a3e0$export$2e2bcd8739ae039)();
(0, $c181609a2822c4d3$export$2e2bcd8739ae039)() // Faz as implementações relacionadas aos inlines
;
(0, $3d674e921bc9a223$export$2e2bcd8739ae039)() // muda class ativa nos inputs
;
(0, $26cf995f5276a8f6$export$2e2bcd8739ae039)();
(0, $35e50930b820f781$export$2e2bcd8739ae039)() //mostra elemento de acordo com parametro na url
;
(0, $0766db45a0d564be$export$2e2bcd8739ae039)();
(0, $0e9464acf29c4d03$export$2e2bcd8739ae039)();
(0, $0460917e066ef034$export$2e2bcd8739ae039)();
(0, $c57268cbdda7e760$export$2e2bcd8739ae039)();
(0, $952685f69e534542$export$2e2bcd8739ae039)() //adiona um filtro na url e recarrega
;
(0, $3e074429cadb145d$export$2e2bcd8739ae039)();
(0, $7ea5127b6ed5228b$export$2e2bcd8739ae039)();
(0, $2c624524ddc404f0$export$2e2bcd8739ae039)();
(0, $e9b61f650e542eed$export$2e2bcd8739ae039)();
(0, $712fc3ffc02f9551$export$2e2bcd8739ae039)();
(0, $fb55be7f197d78d8$export$2e2bcd8739ae039)();
const $ad253d60d7afe5ec$var$menu = (0, $26cf995f5276a8f6$export$2e2bcd8739ae039)(subMenuItens)?.init();
window.myLoader = (0, $afec8e251cea5e73$export$2e2bcd8739ae039);
window.menu = $ad253d60d7afe5ec$var$menu;
window.modalFiltrar = (0, $b9e705216f990553$export$2e2bcd8739ae039);
window.tabs = (0, $0e9464acf29c4d03$export$2e2bcd8739ae039);
document.addEventListener('DOMContentLoaded', ()=>document.body.classList.add('DOMContentLoaded'));

})();
//# sourceMappingURL=main.js.map
